import { StyleSheet } from 'aphrodite'

import headers from './headers'
import buttons from './buttons'

export default {
  headers: StyleSheet.create(headers),
  buttons: StyleSheet.create(buttons)
}



// WEBPACK FOOTER //
// ./src/components/User/style/index.js